import React from 'react';
import './VideoWithText.css';
import { AnimatedSection } from '../../AnimatedSection';

const VideoWithText = () => {
  return (
    <section className="video-with-text section">
      {/* Background Video */}
      <div className="background-video-container">
        


          <video
            className="background-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          >
            <source src="/home_data/section1/1AM.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

{/* 
        <video className="background-video"  playsinline autoplay="" muted="" loop="" src="/home_data/section1/home2025fhd.mp4"  ></video> */}

        {/* Overlay Content */}
        <div className="video-overlay">
          <div className="video-content">
            {/* Left side - Image mark */}
            <div className="left-content">
              <div className="image-mark">
                <img src="/home_data/section3/Group 526.png" alt="Mark" className="mark-image" />
              </div>
            </div>

            {/* Right side - Text content */}
            <div className="right-content">
              <div className="text-content">
                <div className="video-title-section3">
                  <span className="word1">WIN</span> &nbsp;
                  <span className="word2">OR</span> <br />
                  <span className="word3" style={{ marginTop: '-20px' }}>GO</span>  &nbsp;
                  <span className="word4" style={{ marginTop: '-20px' }}>HOME</span>
                </div>
                <AnimatedSection>
                  <p className="video-description">
                    GAME 7 is a multi-platform sports & entertainment brand underscoring the journey to success.
                    We are creating a community that celebrates the stories of perseverance, success, and performance under pressure —
                    through league-backed products, premium events, and authentic experiences that bring untold stories to life.
                  </p>
                </AnimatedSection>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoWithText;
